import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-5 custom-footer"
}
const _hoisted_2 = { class: "container text-center" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-md-4 mb-4 custom-tc-links" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "col-12 col-md-4 mb-4 custom-quick-links" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-uppercase fw-bold small mb-2 fs-6" }, " Accesos Rápidos ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", {
  class: "mx-auto",
  style: {"width":"25%","height":"2px","background-color":"white"}
}, null, -1)
const _hoisted_9 = { class: "text-uppercase" }
const _hoisted_10 = { class: "col-12 col-md-4 mb-4" }
const _hoisted_11 = { href: "#" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 0,
  class: "small mt-3"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  target: "_blank",
  rel: "noopener",
  class: "d-block mb-2",
  style: {"color":"var(--terciary)"}
}, " www.clubpassione.com.ar ", -1)
const _hoisted_15 = { class: "d-flex justify-content-center gap-3 mt-2 custom-social-icons" }
const _hoisted_16 = ["href", "aria-label"]

import { useStore } from 'vuex'
import { key } from '@/setup/store'
import { VuexStore } from '@/interfaces/VuexStore'
import useImageSever from '@/composables/useImageServer'
import VRedes from './rebranding/VRedes.vue'
import { RouterLink } from 'vue-router'
import useMenu from '@/composables/useMenu'
import { computed } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooterComponent',
  setup(__props) {

const { getPathImageServer } = useImageSever()
const { state } = useStore<VuexStore>(key)
const { menu } = useMenu()

const redesOrdenadas = computed(() => {
  const redes = { ...state.evento.redes }

  const orden = [
    { nombre: 'facebook', icon: 'fab fa-facebook-f' },
    { nombre: 'x', icon: 'fab fa-twitter' },
    { nombre: 'twitter', icon: 'fab fa-twitter' },
    { nombre: 'instagram', icon: 'fab fa-instagram' },
    { nombre: 'youtube', icon: 'fab fa-youtube' },
    { nombre: 'whatsapp', icon: 'fab fa-whatsapp' },
    { nombre: 'linkedin', icon: 'fab fa-linkedin' }
  ]

  return orden
    .filter(item => redes[item.nombre])
    .map(item => {
      const url = redes[item.nombre]
      const numero = item.nombre === 'whatsapp'
        ? extraerNumeroDeWhatsapp(url)
        : null

      return {
        ...item,
        url,
        numero
      }
    })
})

function extraerNumeroDeWhatsapp(url: string): string {
  const match = url.match(/phone=(\d+)/)
  return match ? `+${match[1]}` : ''
}

return (_ctx: any,_cache: any) => {
  return (_unref(state).evento)
    ? (_openBlock(), _createElementBlock("footer", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(RouterLink), {
                  class: "d-block my-4",
                  to: { name: 'ProvacyPolicies' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Política de privacidad ")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(RouterLink), {
                  class: "d-block my-4",
                  to: { name: 'Cookies' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Preferencia de cookies ")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(VRedes)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (hash) => {
                  return (_openBlock(), _createBlock(_unref(RouterLink), {
                    key: hash,
                    class: "nav-link text-uppercase",
                    to: { name: 'Home', hash: '#' + hash }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(hash), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("a", _hoisted_11, [
                _createElementVNode("img", {
                  src: _unref(getPathImageServer)(_unref(state).evento.logo),
                  alt: "Logo",
                  class: "img-fluid",
                  style: {"max-height":"4rem","object-fit":"contain"}
                }, null, 8, _hoisted_12)
              ]),
              (_unref(state).evento?.theme === 'fiat_fidelizacion')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(redesOrdenadas), (item) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: item.nombre,
                          href: item.url,
                          target: "_blank",
                          rel: "noopener",
                          "aria-label": item.nombre,
                          class: "d-flex align-items-center gap-1"
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(item.icon),
                            style: {"font-size":"1.5rem","color":"var(--terciary)"}
                          }, null, 2)
                        ], 8, _hoisted_16))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})